import { Dispatch, Action } from 'redux';
import { CompanyValidation } from '../reducers/companyValidations.reducer'
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
// import { NotificationManager } from 'react-notifications';
import { getCompanyValidationsAPI } from '../../config/config'
import { toast } from 'react-toastify'


// Action types
export const GET_COMPANYVALIDATIONS_REQUEST = 'GET_COMPANYVALIDATIONS_REQUEST';
export const GET_COMPANYVALIDATIONS_SUCCESS = 'GET_COMPANYVALIDATIONS_SUCCESS';
export const GET_COMPANYVALIDATIONS_FAILURE = 'GET_COMPANYVALIDATIONS_FAILURE';





export const RESET_COMPANYVALIDATION_STATE = 'RESET_COMPANYVALIDATION_STATE'


interface GetCompanyValidationsRequest extends Action<typeof GET_COMPANYVALIDATIONS_REQUEST> { }
interface GetCompanyValidationsSuccess extends Action<typeof GET_COMPANYVALIDATIONS_SUCCESS> {
  payload: { validations: CompanyValidation[] , totalCount: number, page:number }
}
interface GetCompanyValidationsFailure extends Action<typeof GET_COMPANYVALIDATIONS_FAILURE> {
  payload: string
}

interface ResetCompanyValidationState extends Action<typeof RESET_COMPANYVALIDATION_STATE> {}

export type ActionTypes = GetCompanyValidationsRequest | GetCompanyValidationsSuccess | GetCompanyValidationsFailure  
  | ResetCompanyValidationState

// Action creators
const getCompanyValidationsRequest = (): GetCompanyValidationsRequest => ({ type: GET_COMPANYVALIDATIONS_REQUEST });
const getCompanyValidationsSuccess = (data: CompanyValidation[], totalCount: number, page: number): GetCompanyValidationsSuccess => ({ type: GET_COMPANYVALIDATIONS_SUCCESS, payload: {validations: data , totalCount, page}});

const getCompanyValidationsFailure = (error: string): GetCompanyValidationsFailure => ({ type: GET_COMPANYVALIDATIONS_FAILURE, payload: error });
const resetCompanyValidationState = (): ResetCompanyValidationState => ({type:RESET_COMPANYVALIDATION_STATE})


// Async action creators
const getCompanyValidations = (uuid:string, params: any) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getCompanyValidationsRequest());
      
      let query = ''
      if(params){
        const queryParams = new URLSearchParams();
        Object.keys(params).forEach(key => {
          if (params[key] !== undefined && params[key] !== null && params[key] !== 'all') {
            queryParams.append(key, params[key]);
          }
        });
        query = queryParams.toString() ? `?${queryParams.toString()}` : '';
      }
          
      const response = await getCompanyValidationsAPI(uuid, query);      
      dispatch(getCompanyValidationsSuccess(response?.data?.validations || [], response?.data?.totalCount, response?.data?.page || 0))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getCompanyValidationsFailure(error.message));
    }
  };
};


const resetAll = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetCompanyValidationState())
  };
}


const actions = {
  getCompanyValidations,
  resetAll
}

export default actions
